import {Component, input, ChangeDetectionStrategy} from '@angular/core';
import {FormTemplate} from '../forms.model';

@Component({
    selector: 'app-form-display',
    templateUrl: './form-display.component.html',
    styleUrls: ['./form-display.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FormDisplayComponent  {
  readonly form = input<FormTemplate>(undefined);

}
